<template>
  <div class="header">

    <div class="title">
      <h1>Portail de paiement en ligne PAYFIP</h1>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  background-color: #1d3f5f; /* IE */
  background-color: var(--primary-dark);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);
}

.header > div {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

/* Première partie */

/* Deuxième partie */

/* Troisième partie */

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .header > div {
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue